import { AxiosPromise } from 'axios'

import api from '@config/api'

export function getCenters(): AxiosPromise {
  return api.get('v1/Empresa')
}
export function getCentersParametrization(): AxiosPromise {
  return api.get('v1/Loja/CentroDistribuicao')
}
export function getStore(): AxiosPromise {
  return api.get('v1/Loja')
}
export function getCategories(): AxiosPromise {
  return api.get('v1/Categoria')
}

export function getCompanies(): AxiosPromise {
  return api.get('v1/Empresa')
}
export function getCompactCategories(): AxiosPromise {
  return api.get('v1/CategoriaCompacta')
}

export function getWorlds(): AxiosPromise {
  return api.get('v1/Mundo')
}

export function getDistributionCenters(): AxiosPromise {
  return api.get('v1/Loja/CentroDistribuicao')
}

export function getSuppliersForPurschase(): AxiosPromise {
  return api.get('v1/Fornecedor')
}

export function getSuppliersForDistribution(): AxiosPromise {
  return api.get('v1/Fornecedor')
}

export function getProductsForPurschase(): AxiosPromise {
  return api.get('v1/Produto/Compras')
}

export function getProductsForDistribution(): AxiosPromise {
  return api.get('v1/Produto/Distribuicoes')
}

export function getProducts(): AxiosPromise {
  return api.get('v1/Produto')
}

export function completeMinimumOrderSupplier(data: any): AxiosPromise {
  return api.put('v1/Fornecedor/Pedidos/Minimo', {
    recomendacaoFornecimentos: data
  })
}

export function update(data: any): AxiosPromise {
  return api.put('v1/ParametroAbastecimento', data, {})
}

interface IGetSupplyData {
  page?: number
  params: {
    [key: string]: number[] | boolean | string | number | any[] | any | Blob
  }
  isProgramada?: boolean
}

interface IDeleteData {
  idMinimumBilling?: number
}

interface IUploadData {
  file?: any
}

interface IGetSimilarProduct {
  page?: number
}

interface IPutRevisionData {
  params: { [key: string]: number[] | boolean | string | number | any }
}

export function getSupplyData({
  params: filters,
  page
}: IGetSupplyData): AxiosPromise {
  return api.post('v1/ParametroAbastecimento', filters, {
    params: {
      pagination: JSON.stringify({
        actualPage: page,
        rows: 200
      })
    }
  })
}

export function getSupplyDataAll({
  params: filters
}: IGetSupplyData): AxiosPromise {
  return api.post('v1/ParametroAbastecimento', filters, {})
}
export function getRevisionData({
  params: filters
}: IGetSupplyData): AxiosPromise {
  return api.post('v1/ParametroRevisao', filters, {})
}

export function putRecusedRevision({
  params: filters
}: IPutRevisionData): AxiosPromise {
  return api.put('v1/ParametroRevisao/Recusar', filters, {})
}

export function putAprovedRevision({
  params: filters
}: IPutRevisionData): AxiosPromise {
  return api.put('v1/ParametroRevisao/Aprovar', filters, {})
}

export function putProductSimilar({
  params: filters
}: IPutRevisionData): AxiosPromise {
  return api.put('v1/ParametroProdutoSimilar', filters, {})
}

export function deleteProductSimilar({
  idMinimumBilling: id
}: IDeleteData): AxiosPromise {
  return api.delete(`v1/ParametroProdutoSimilar/${id}`, {})
}

// export function getSimilarProductsData({
//   page = 1
// }: IGetSimilarProduct): AxiosPromise {
//   return api.post('v1/ParametroProdutoSimilar/Filtro', {}, {})
// }

export function getSimilarProductsData(
  search: any,
  page: any,
  take: any,
  obj: any
): AxiosPromise {
  const url = 'v1/ParametroProdutoSimilar/Filtro'

  return api.post(url, obj, {
    params: {
      pagination: JSON.stringify({
        actualPage: page,
        rows: take
      })
    }
  })
}

export function getMinimumBilling({
  // eslint-disable-next-line unused-imports/no-unused-vars
  page = 1
}: IGetSimilarProduct): AxiosPromise {
  return api.post('v1/ParametroFaturamentoMinimo/Filtro', {}, {})
}

export function postNewProductSimilar({
  params: filters
}: IGetSupplyData): AxiosPromise {
  return api.post('v1/ParametroProdutoSimilar', filters, {})
}

export function postMinimumBilling({
  params: filters
}: IGetSupplyData): AxiosPromise {
  return api.post('v1/ParametroFaturamentoMinimo', filters, {})
}

export function putMinimumBilling({
  params: filters
}: IGetSupplyData): AxiosPromise {
  return api.put('v1/ParametroFaturamentoMinimo', filters, {})
}

export function deleteMinimumBilling({
  idMinimumBilling: id
}: IDeleteData): AxiosPromise {
  return api.delete(`v1/ParametroFaturamentoMinimo/${id}`, {})
}

export function uploadSupply({ file: fileUpload }: IUploadData): AxiosPromise {
  const formData = new FormData()
  formData.append('file', fileUpload)
  return api.post('v1/ParametroAbastecimento/Arquivo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function uploadSupplyIncrement({
  file: fileUpload
}: IUploadData): AxiosPromise {
  const formData = new FormData()
  formData.append('file', fileUpload)
  return api.post('v1/ParametroIncrementoEstoque/Arquivo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function uploadSupplyProductSimilar({
  file: fileUpload
}: IUploadData): AxiosPromise {
  const formData = new FormData()
  formData.append('file', fileUpload)
  return api.post('v1/ParametroProdutoSimilar/Arquivo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export interface IHistoricoExportarParams {
  periodo: { inicio: string; final: string }
  empresasIds?: number[]
  lojasIds?: number[]
  produtosIds?: number[]
  usuarios?: string[]
}

export function postExportHistorico(
  data: IHistoricoExportarParams
): AxiosPromise {
  return api.post('v1/ParametroAbastecimento/Historico/Exportar', data, {
    responseType: 'blob',
    timeout: 300000
  })
}

export function postExportSupply(data: any): AxiosPromise {
  return api.post('v1/ParametroAbastecimento/Exportar', data, {})
}

export function postExportSupplyBackend(data: any): AxiosPromise {
  return api.post('v1/ParametroAbastecimento/exportar', data, {
    responseType: 'blob'
  })
}
export function cargaProdutosSimilares(
  produtos: Array<{
    EmpresaId: number
    ProdutoNovoId: number
    ProdutoSimilarId: number
    DemandaAbsorvida: number
    DataInicio: string
    DataFim: string
  }>
): AxiosPromise {
  return api.post('v1/ParametroProdutoSimilar/Carga', { Produtos: produtos })
}

export function postExportSimilarProduct(data: any): AxiosPromise {
  return api.post('v1/ParametroProdutoSimilar/Exportar', data, {})
}
export function postExportMinimumBilling(data: any): AxiosPromise {
  return api.post('v1/ParametroFaturamentoMinimo/Exportar', data, {})
}
export function postExportRevision(data: any): AxiosPromise {
  return api.post('v1/ParametroRevisao/Exportar', data, {})
}
export function getHistoric(idProduto: number, idLoja: number): AxiosPromise {
  return api.get(
    `v1/ParametroAbastecimento/Historico-Equalizacao/Loja/${idLoja}/Produto/${idProduto}/14-06-22`
  )
}
export function getHistoricV2(idProduto: number, idLoja: number): AxiosPromise {
  return api.get(
    `v1/ParametroAbastecimento/Historico-Equalizacao/Loja/${idLoja}/Produto/${idProduto}/21-06-22`
  )
}
export function getHistoricV3(idProduto: number, idLoja: number): AxiosPromise {
  return api.get(
    `v1/ParametroAbastecimento/Historico-Equalizacao/Loja/${idLoja}/Produto/${idProduto}/05-07-22`
  )
}
export function getHistoricUpdate(
  idProduto: number,
  idLoja: number
): AxiosPromise {
  return api.get(
    `v1/ParametroAbastecimento/Historico/Loja/${idLoja}/Produto/${idProduto}`
  )
}
export function getHistoricUpdateProductSimilar(
  idSimilar: number
): AxiosPromise {
  return api.get(`v1/ParametroProdutoSimilar/Historico/${idSimilar}`)
}

export function getHistoricLeadTime(
  idProduto: number,
  idLoja: number
): AxiosPromise {
  return api.get(
    `v1/LeadTimeAutomatizado/Historico/Loja/${idLoja}/Produto/${idProduto}`
  )
}

export function getSettingsParams(): AxiosPromise {
  return api.get('v1/ParametroAbastecimento/Configuracoes/Perfis')
}

export function postSettingsParams(data: any): AxiosPromise {
  return api.post('v1/ParametroAbastecimento/Configuracoes', data, {})
}

// IncrementSupplier
export function getParamsIncrementSupplier(
  search: any,
  page: any,
  take: any,
  obj: any
): AxiosPromise {
  const url = 'v1/ParametroIncrementoEstoque/filtro'

  return api.post(url, obj, {
    params: {
      pagination: JSON.stringify({
        actualPage: page,
        rows: take
      })
    }
  })
}

export function postParamsIncrementSupplier(data: any): AxiosPromise {
  return api.post('v1/ParametroIncrementoEstoque', data, {})
}

export function removeParamsIncrementSupplier(data: any): AxiosPromise {
  return api.post('v1/ParametroIncrementoEstoque/remover', data, {})
}

export function getOtimizer(data: any): AxiosPromise {
  return api.post('v1/OtimizadorEstoque', data, {})
}

export function getOtimizerTraderOff(data: any): AxiosPromise {
  return api.post('v1/OtimizadorEstoque/TradeOff', data, {})
}
export function getOtimizerTraderOffWithPoint(
  data: any,
  point: any
): AxiosPromise {
  return api.post('v1/OtimizadorEstoque/TradeOff/' + point, data, {})
}

export function getOtimizerDefault(): AxiosPromise {
  return api.get('v1/OtimizadorEstoque/Default')
}

export function saveOtimizer(data: any): AxiosPromise {
  return api.put('v1/OtimizadorEstoque', data, {})
}

export function getHistoricOptimizer(): AxiosPromise {
  return api.get('v1/OtimizadorEstoque/Historico')
}

export default {
  getCenters,
  getStore,
  getCompanies,
  getCategories,
  getCompactCategories,
  getWorlds,
  getSuppliersForPurschase,
  postExportSimilarProduct,
  getProducts,
  getSuppliersForDistribution,
  getProductsForPurschase,
  getProductsForDistribution,
  getDistributionCenters,
  getSupplyData,
  getRevisionData,
  getSettingsParams,
  postExportSupply,
  postExportSupplyBackend,
  postExportRevision,
  update,
  getSimilarProductsData,
  postExportMinimumBilling,
  getHistoric,
  postNewProductSimilar,
  getMinimumBilling,
  postMinimumBilling,
  putMinimumBilling,
  putAprovedRevision,
  putRecusedRevision,
  deleteMinimumBilling,
  putProductSimilar,
  uploadSupply,
  uploadSupplyIncrement,
  deleteProductSimilar,
  getHistoricV2,
  getCentersParametrization,
  completeMinimumOrderSupplier,
  getHistoricV3,
  getHistoricUpdate,
  getSupplyDataAll,
  postSettingsParams,
  getParamsIncrementSupplier,
  postParamsIncrementSupplier,
  removeParamsIncrementSupplier,
  getHistoricLeadTime,
  getHistoricUpdateProductSimilar,
  getOtimizer,
  getOtimizerTraderOff,
  getOtimizerTraderOffWithPoint,
  getOtimizerDefault,
  uploadSupplyProductSimilar,
  cargaProdutosSimilares,
  saveOtimizer,
  getHistoricOptimizer,
  postExportHistorico
}
